import Component from "../../lib/component";
import iconForwardChevron from "./assets/icon__forward_chevron.svg";

export const DropdownBtnConfig = {
    componentTypeKey: 'DropdownBtn',
    baseHtmlClass: 'dropdown_btn',
    selector: '.dropdown_btn',
};

export class DropdownBtn extends Component {

    static get config() {
        return DropdownBtnConfig;
    }

    constructor(id_or_element, dropdown, options) {
        super({
            element: id_or_element,
            config: DropdownBtn.config
        });

        this.dropdown = dropdown;
        this.showChevron = options && options.show_chevron;

        this.element.classList.add(DropdownBtn.config.baseHtmlClass);
        this.element.style.cursor = 'pointer';

        if (this.showChevron) {
            this.chevronElement = createChevronElement(this);
        }

        this.element.addEventListener('click', this.handleClick.bind(this));
        this.render();
    }

    handleClick(event) {
        if (event.target.closest('.dropdown')) return;
        event.preventDefault();
        this.toggle();
        this.dropdown.render();
    }

    render() {
        this.swapHtmlClassStates(this.isOpen(), 'open', 'closed');
    }

    toggle() {
        this.dropdown.toggle();
    }

    isOpen() {
        return this.dropdown.isOpen();
    }

}

function createChevronElement(dropdownBtn) {
    const element = document.createElement('span');
    element.classList.add('dropdown_btn__chevron');
    const svgElement = new DOMParser().parseFromString(iconForwardChevron, "image/svg+xml").documentElement;
    svgElement.style.cssText = "display:block;height:100%;width:100%;";
    element.appendChild(svgElement);
    dropdownBtn.element.appendChild(element);
    return element;
}
